enum DocumentFileFormat {
  IMG = 'img',
  PDF = 'pdf',
}

export default DocumentFileFormat
